<template>
    <div>
        <h2 class="mb-3">Kontaktdaten für Mietinteressenten</h2>
        <div class="row mb-5">
            <div class="col-12 col-md-6 mb-3">
                <label>Firma</label>
                <input type="text" class="form-control" v-model.trim="company" placeholder="Firma eingeben">
            </div>
            <div class="col-12 col-md-6 mb-3">
                <label>Anrede</label>
                <select class="form-control" v-model="title">
                    <option value="">Anrede wählen</option>
                    <option value="Herr">Herr</option>
                    <option value="Frau">Frau</option>
                </select>
            </div>
            <div class="col-12 col-md-6 mb-3">
                <label>Vorname*</label>
                <input type="text" class="form-control" v-model.trim="firstname" @blur="$v.firstname.$touch()" :class="{ 'is-invalid': $v.firstname.$error }" placeholder="Vorname eingeben">
                <div class="invalid-feedback" v-if="!$v.firstname.required">Bitte Vorname eingeben</div>
            </div>
            <div class="col-12 col-md-6 mb-3">
                <label>Nachname*</label>
                <input type="text" class="form-control" v-model.trim="lastname" @blur="$v.lastname.$touch()" :class="{ 'is-invalid': $v.lastname.$error }" placeholder="Nachname eingeben">
                <div class="invalid-feedback" v-if="!$v.lastname.required">Bitte Nachname eingeben</div>
            </div>
            <div class="col-12 col-md-6 mb-3">
                <label>E-Mail-Adresse*</label>
                <input type="text" class="form-control lowercase-field" @focusout="emailToLowercase($event)" v-model.trim="email" @blur="$v.email.$touch()" :class="{ 'is-invalid': $v.email.$error }" placeholder="E-Mail-Adresse eingeben">
                <div class="invalid-feedback" v-if="!$v.email.required">Bitte E-Mail-Adresse eingeben</div>
                <div class="invalid-feedback" v-if="!$v.email.email">Bitte eine gültige E-Mail-Adresse eingeben</div>
            </div>
            <div class="col-12 col-md-6 mb-3">
                <label>Telefon-Nummer*</label>
                <input type="text" class="form-control" v-model.trim="phone" @blur="$v.phone.$touch()" :class="{ 'is-invalid': $v.phone.$error }" placeholder="Telefon-Nummer eingeben">
                <div class="invalid-feedback" v-if="!$v.phone.required">Bitte Telefon-Nummer eingeben</div>
            </div>
        </div>
        <div v-if="isMobile" class="mt-3 text-center">
            <button v-if="create" class="btn btn-success w-100"  @click="weiter()">Weiter</button>
            <button v-if="!create" class="btn btn-success mb-1 w-100"  @click="save(true)">Speichern und Schließen</button>
            <button v-if="!create" class="btn btn-success w-100"  @click="save()">Weiter</button>
        </div>
        <div v-else class="mt-3 text-right">
            <button v-if="create" class="btn btn-success"  @click="weiter()">Weiter</button>
            <button v-if="!create" class="btn btn-success mx-2"  @click="save(true)">Speichern und Schließen</button>
            <button v-if="!create" class="btn btn-success"  @click="save()">Weiter</button>
        </div>
        <b-modal ref="error-modal" :title="'Fehlermeldung'">
            <div class="d-block">
                <h5>Sie müssen alle Eingaben eingeben!</h5>
            </div>
            <template slot="modal-footer" slot-scope="{ cancel }">
                <b-button variant="danger" @click="cancel()">Schließen</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import { required, email } from 'vuelidate/lib/validators';
    import Inserat from '../../../classes/Inserat';
    import { IsMobileMixin } from '../../../mixins/IsMobile';

    export default {
        data() {
            return {
                title: '',
                company: '',
                firstname: '',
                lastname: '',
                email: '',
                phone: '',
                user: null
            }
        },
        props:['create'],
        mixins: [IsMobileMixin],
        methods: {
          emailToLowercase(event) {
            if (!event.target.value.match(/([A-Z])+/)) {
              return;
            }

            let email = event.target.value;
            email = event.target.value.toLowerCase();
            this.email = email;
          },
            scrollTop() {
                window.scrollTo(0, 0);
            },
            assignUser() {
                this.title      = this.user.title;
                this.company    = this.user.company;
                this.firstname  = this.user.forename;
                this.lastname   = this.user.surname;
                this.email      = this.user.email;
                this.phone      = this.user.phone;
            },
            weiter(gotoNextTab = true) {
                this.$v.$touch();
                if(! this.$v.$invalid){
                    let jsonObject = JSON.parse(localStorage.getItem('currentObject'));
                    let inserat = Inserat.getObjectFromJSON(jsonObject);

                    inserat.setContact({
                        title: this.title,
                        firstname: this.firstname,
                        lastname: this.lastname,
                        email: this.email,
                        phone: this.phone,
                        company: this.company,
                    });

                    localStorage.setItem('currentObject', JSON.stringify(inserat));
                    if(gotoNextTab){
                        localStorage.setItem('currentObjectTab', 'impressum');
                        this.$emit('nextTab','impressum');
                    }
                }
            },
            save(closeAfter = false) {
                this.$v.$touch();
                if(! this.$v.$invalid){
                    let object = this.$store.state.editObject;

                    object.contact.title     = this.title;
                    object.contact.company   = this.company;
                    object.contact.firstname = this.firstname;
                    object.contact.lastname  = this.lastname;
                    object.contact.email     = this.email ? this.email.toLowerCase() : this.email;
                    object.contact.phone     = this.phone;

                    this.$store.state.loading = true;

                    this.$http.put('/objectApi/updateObject?id='+object.id, object).then(response => {
                        this.$store.state.editObject = object;
                        this.$store.state.loading = false;
                        this.$emit('success', response.data);
                        if(closeAfter){
                            setTimeout(() => {
                                this.$router.push({name: 'inserat-uebersicht', params: {page: this.$store.state.lastOpenedPage}});
                            }, 1000);
                        }
                        else {
                          this.$emit('nextTab', 'impressum');
                        }
                    }).catch(error => {
                        this.$store.state.loading = false;
                        this.$emit('error', error.response.data.data);
                    });
                }
            }
        },
        mounted() {
            this.scrollTop();
            if(this.create){
                let jsonObject = JSON.parse(localStorage.getItem('currentObject'));
                let inserat    = Inserat.getObjectFromJSON(jsonObject);
                let contact    = inserat.getContact();

                if(contact && Object.keys(contact).length > 0){
                    this.title      = contact.title;
                    this.company    = contact.company;
                    this.firstname  = contact.firstname;
                    this.lastname   = contact.lastname;
                    this.email      = contact.email ? contact.email.toLowerCase() : contact.email;
                    this.phone      = contact.phone;
                }else{
                    this.user = this.$store.getters.user;
                    if(this.user != null){
                        this.assignUser();
                    }
                    this.$store.watch( () => {
                            return this.$store.getters.user;
                        }, (user) =>{
                            this.user = user;
                            this.assignUser();
                        }
                    );
                }
            }else {
                let contact    = this.$store.getters.editObject.contact;
                this.user      = this.$store.getters.user;

                this.title     = contact.title     ? contact.title     : this.user.title;
                this.company   = contact.company   ? contact.company   : this.user.company;
                this.firstname = contact.firstname ? contact.firstname : this.user.forename;
                this.lastname  = contact.lastname  ? contact.lastname  : this.user.surname;
                this.email     = contact.email     ? contact.email     : this.user.email;
                this.phone     = contact.phone     ? contact.phone     : this.user.phone;
            }
        },
        validations: {
            firstname: {required},
            lastname: {required},
            email: {required, email},
            phone: {required},
        },
        beforeDestroy() {
          if(this.create){
            this.weiter(false);
          }
        }

    }
</script>

<style scoped>
.lowercase-field {
  text-transform: lowercase;
}
</style>
